import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-skipforward",
  "use": "icon-th-skipforward-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-skipforward\">\n<path d=\"M25 4C24.7348 4 24.4804 4.10536 24.2929 4.29289C24.1054 4.48043 24 4.73478 24 5V13.6538L9.05375 4.30625C8.75275 4.1173 8.40672 4.01224 8.05147 4.00194C7.69623 3.99165 7.34469 4.0765 7.03326 4.2477C6.72182 4.41891 6.46181 4.67025 6.28014 4.9757C6.09848 5.28115 6.00176 5.62961 6 5.985V26.015C6.00374 26.3696 6.10168 26.7168 6.2838 27.0211C6.46592 27.3254 6.72566 27.5757 7.03641 27.7466C7.34716 27.9174 7.69774 28.0025 8.05223 27.9932C8.40672 27.984 8.75236 27.8806 9.05375 27.6938L24 18.3463V27C24 27.2652 24.1054 27.5196 24.2929 27.7071C24.4804 27.8946 24.7348 28 25 28C25.2652 28 25.5196 27.8946 25.7071 27.7071C25.8946 27.5196 26 27.2652 26 27V5C26 4.73478 25.8946 4.48043 25.7071 4.29289C25.5196 4.10536 25.2652 4 25 4ZM8 25.9912V6.00625L23.98 16.0063L8 25.9912Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-skipforward.svg
// module id = fJih
// module chunks = 84